import { Modal } from 'antd';
import { ButtonMain } from '../button';
import managerSvg from '@@/seller-account/images/manager.svg';
import styles from './index.module.sass';
import { useStore } from 'effector-react';
import { $displayBuySubscription, switchDisplayBuySubscription } from '@/modules/auth/store/auth.store';

export const NotifierModal = ({
  initialState,
  label,
}: {
  initialState?: boolean,
  label: string | JSX.Element;
}) => {
  const displayBuySubscription = useStore($displayBuySubscription);

  return (
    <Modal
      open={displayBuySubscription}
      width={426}
      onCancel={() => switchDisplayBuySubscription(false)}
      footer={
        <div className={styles.modalFooter}>
          <ButtonMain
            className={styles.footerButton}
            label="понятно"
            onClick={() => switchDisplayBuySubscription(false)}
          />
        </div>
      }
      closeIcon={null}
    >
      <div className={styles.modalRoot}>
        <img src={managerSvg} width={261} alt="manager" />
        <span>{label}</span>
      </div>
    </Modal>
  );
};
